import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import { Icons } from 'msp-components'
import translations from './PaymentMethodDisplay.constants'
import { PaymentMethodTypePayPalProps } from './PaymentMethodDisplay.types'
import * as S from './PaymentMethodDisplay.styles'

const PaymentMethodTypePayPal = ({
  className = '',
  extendedDetails,
  paymentInstrument
}: PaymentMethodTypePayPalProps) => {
  const { formatMessage } = useIntl()

  return (
    <div className={twMerge(S.PaymentMethodDisplayWrapper, className)}>
      <div className={S.PaymentMethodDisplayIconWrapper}>
        <Icons iconName='PayPal' size='3xl' />
      </div>
      <div className={S.PaymentMethodDisplayContentWrapper}>
        <div className={S.PaymentMethodDisplayNameWrapper}>
          {formatMessage(translations.UNZER_PAYPAL)}
        </div>
        {extendedDetails && (
          <>
            <div className={S.PaymentMethodDisplayStandardWrapper}>
              {formatMessage(translations.payPayEmail, {
                paypalEmail: paymentInstrument.c_email
              })}
            </div>
            <div className={S.PaymentMethodDisplayNoteWrapper}>
              {formatMessage(translations.paymentNote)}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default PaymentMethodTypePayPal
